import React from "react";
import { Link } from "react-router-dom";

const SingleCategory = ({ name, imageSrc }) => {
  return (
    <Link to="/category">
      <div className="category flex w-28 cursor-pointer flex-col items-center">
        <img src={imageSrc} alt="" className="mb-2 w-full" />
        <p className="font-pop text-[10px] font-normal text-black">{name}</p>
      </div>
    </Link>
  );
};

export default SingleCategory;
